const departments = {
    leader: 'Leader',
    leaders: 'Department leaders',
    led_departments: 'Departments you lead',
    edit_leaders: 'Manage leaders',
    add_leader: 'Add',
    remove_leader: 'Remove',
    no_leaders: 'No leaders assigned',
    local: 'Locally managed',
    managed_members: 'Members in your management scope',
    leader_scope_hint: 'Manage member assignments in departments you lead and their subdepartments.',
    leader_permission_hint: 'Leaders manage member assignments within their departments and descendants, without organization role or hierarchy management.',
    primary_synced: 'Primary department is managed by Feishu.',
    status_active: 'Active',
    status_suspended: 'Suspended',
    status_departed: 'Departed',
    status_pending: 'Pending activation',
    search: 'Search',
    previous_page: 'Previous page',
    next_page: 'Next page',
    directory_title: 'Organization members',
    member_name: 'Member',
    search_members: 'Search by name or username',
    include_descendants: 'Include subdepartments',
    no_members: 'No matching members.',
    all_members: 'All members',
    all_departments: 'All departments',
    edit_member: 'Edit departments',
    add_child: 'Add subdepartment',
    expand_department: 'Expand {{name}}',
    collapse_department: 'Collapse {{name}}',
    title: 'Departments',
    description: 'Manage departments and member assignments within this organization.',
    create: 'Create department',
    edit: 'Edit department',
    name: 'Department name',
    parent: 'Parent department',
    root: 'No parent department',
    id: 'Department ID',
    members: 'Member departments',
    member_id: 'Member user ID',
    primary: 'Primary department',
    none: 'Not set',
    assignments: 'Department assignments',
    no_assignments: 'No department assignments yet.',
    assignment_hint: 'Assign local departments and optionally a primary department. Directory-managed assignments are read-only.',
    empty: 'No departments yet.',
    readonly: 'You can view departments and your assignments. Contact an organization administrator to make changes.',
    load_error: 'Unable to load data. Please try again.',
    mutation_error: 'Unable to save. Check your permissions, membership and department hierarchy.',
    loading: 'Loading…',
    synced: 'Directory managed',
    choose: 'Search departments',
    organizations_title: 'Organizations & departments',
    organizations_description: 'Choose an organization to view or manage its departments.',
    no_organizations: 'You have not joined an organization. Contact an organization administrator.',
    organization: 'Current organization',
    choose_organization: 'Choose an organization',
    delete_title: 'Delete department',
    delete_description: 'Delete “{{name}}”? Move its members and child departments first.',
};
export default Object.freeze(departments);
